import { Settings } from '../types/Settings';
import {
  CreateSpaceRequest,
  InviteUserToSpaceRequest,
  Space,
  SpaceCredits,
  SpaceDetails,
  UpdateSpaceRequest,
} from '../types/Space';
import { SPACE_API_URL } from './constants';
import { del, get, patch, post } from './requestMethods';

export const SPACE_API = {
  inviteUserToSpace: async (spaceId: string, data: InviteUserToSpaceRequest) =>
    post<void>(`${SPACE_API_URL}/${spaceId}/invite`, { data }),
  leaveSpace: async (spaceId: string) => get<void>(`${SPACE_API_URL}/${spaceId}/leave`),
  createSpace: async (data: CreateSpaceRequest) => post<Space>(SPACE_API_URL, { data }),
  deleteInvitedUserFromSpace: async (spaceId: string, member_id: string) =>
    del<void>(`${SPACE_API_URL}/${spaceId}/invite/remove`, { data: { invite_id: member_id } }),
  deleteSpace: async (spaceId: string) => del<void>(`${SPACE_API_URL}/${spaceId}`),
  deleteUserFromSpace: async (spaceId: string, member_id: string) =>
    del<void>(`${SPACE_API_URL}/${spaceId}/members/remove`, { data: { member_id } }),
  getSpaceById: async (spaceId: string) => get<SpaceDetails>(`${SPACE_API_URL}/${spaceId}`),
  getSpaceCredits: async (spaceId: string) => get<SpaceCredits>(`${SPACE_API_URL}/${spaceId}/credits`),
  getSpaces: async () => get<Space[]>(SPACE_API_URL),
  getSpaceSettings: async (spaceId: string) => get<Settings>(`${SPACE_API_URL}/${spaceId}/settings`),
  updateSpace: async (spaceId: string, data: UpdateSpaceRequest) =>
    patch<Space>(`${SPACE_API_URL}/${spaceId}`, { data }),
};
